import { Box, LinkCard } from '@bymason-private/legacy-pattern-components';

export function NoBuilds({ onBuildCreateClick, justifyContent = 'center' }: NoBuildsProps) {
  return (
    <Box sx={{ width: '100%', paddingTop: 6, display: 'flex', justifyContent: justifyContent, gap: 3 }}>
      <LinkCard
        message='Build in Controller'
        Component={
          <img
            src='https://mcdn.bymason.com/runway/controller/empty-state-builds.svg'
            alt='Make a build to distribute to your Mason devices'
            width='160'
          />
        }
        onClick={onBuildCreateClick}
      />
      <LinkCard
        message='Build using the CLI'
        Component={
          <img
            src='https://mcdn.bymason.com/runway/controller/empty-state-docs.svg'
            alt='Visit our documentation site about building using the command line'
          />
        }
        href='https://docs.bymason.com/setup-guide#build-and-deploy-your-project-using-the-mason-cli'
        target='_blank'
        rel='noopener noreferrer'
      />
    </Box>
  );
}

interface NoBuildsProps {
  onBuildCreateClick: () => void;
  justifyContent?: string;
}
